<template>
  <div
    class="tabs"
    :class="{
      'tabs-secondary': props.variant == TirPmTabsVariantEnum.Secondary,
      'tabs-primary': props.variant == TirPmTabsVariantEnum.Primary,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { PropType, provide } from "vue";
import { ModelThrowComponentsTab } from "..";
import { TirPmTabsVariantEnum } from "./Enums";

const props = defineProps({
  variant: {
    type: String as PropType<TirPmTabsVariantEnum>,
    default: TirPmTabsVariantEnum.Primary,
  },
  modelValue: {
    default: null,
    type: [String, Number, Symbol] as PropType<ModelThrowComponentsTab>,
  },
});

const emit = defineEmits<{
  (eventName: "update:modelValue", value: ModelThrowComponentsTab): void;
}>();

provide("injectFromTab", (data: ModelThrowComponentsTab) => {
  emit("update:modelValue", data);
});
</script>

<style lang="scss">
@import "./style.scss";
</style>
